import { socialExport } from '@mi-front/api-clients';
import { Avatar, Chip, ChipProps } from '@mui/material';

type Props = {
  playlist: socialExport.YoutubePlaylistDto;
} & Omit<ChipProps, 'label' | 'avatar'>;

/**
 * Tag component for displaying a selected YouTube playlist in the autocomplete field.
 * Shows the playlist title with an avatar containing either the thumbnail image
 * or the first letter of the title.
 */
export function YoutubePlaylistTag({ playlist, ...chipProps }: Props) {
  return (
    <Chip
      {...chipProps}
      label={playlist.title}
      avatar={
        <Avatar variant="rounded" sx={{ width: 24, height: 24 }}>
          {playlist.thumbnailUrl ? (
            <img
              src={playlist.thumbnailUrl}
              alt={playlist.title}
              loading="lazy"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            playlist.title.charAt(0).toUpperCase()
          )}
        </Avatar>
      }
    />
  );
}
